import Loading from "components/common/Loading";
import { EPath } from "constants/path";
import { useAuth } from "contexts/AuthContext";
import { useToast } from "contexts/ToastContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

function AuthActionPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { showError, showSuccess } = useToast();
  const { verifyEmail } = useAuth();

  const params = new URLSearchParams(window.location.search);
  const mode = params.get("mode");
  const oobCode: string | null = params.get("oobCode");

  const handleVerifyEmail = async (oobCode: string) => {
    try {
      setIsLoading(true);
      await verifyEmail(oobCode);
      showSuccess("Email verified successfully");
    } catch (error) {
      const authError = error as Error;
      showError("Verification failed", authError.message);
    } finally {
      setIsLoading(false);
      navigate(EPath.LOGIN);
    }
  };

  useEffect(() => {
    if (!mode || !oobCode) {
      navigate(EPath.LOGIN);
      return;
    }

    const processAuthAction = async () => {
      if (mode === "resetPassword") {
        navigate(EPath.RESET_PASSWORD, {
          state: {
            oobCode,
          },
        });
        return;
      }

      if (mode === "verifyEmail") {
        await handleVerifyEmail(oobCode);
      }
    };

    void processAuthAction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) return <Loading />;
}

export default AuthActionPage;
